import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { RESOURCE_STATUS } from '../../../common/constants';

/**
 * The "⋮" menu at the end of each row.
 *
 * Props:
 *   id       (string)   - ID prefix for generated element IDs.
 *   row      (object)   - The resource this menu belongs to.
 *   onEdit   (function) - Omit to hide Edit; flashcard decks have no editor yet.
 *   onDelete (function) - Called with the row.
 */
export const ActionsMenu = ({ id, row, onEdit, onDelete }) => {
  const [anchor, setAnchor] = useState(null);
  const isMenuOpen = Boolean(anchor);
  const buttonId = `${id}__iconButton_actions_${row.id}`;
  const menuId = `${id}__menu_actions_${row.id}`;

  const closeThen = (action) => () => {
    setAnchor(null);
    action(row);
  };

  return (
    <>
      <IconButton
        id={buttonId}
        size="small"
        onClick={(e) => {
          // Without this the click also opens the row.
          e.stopPropagation();
          setAnchor(e.currentTarget);
        }}
        aria-label="Row actions"
        aria-controls={isMenuOpen ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </IconButton>

      <Menu
        id={menuId}
        aria-labelledby={buttonId}
        anchorEl={anchor}
        open={isMenuOpen}
        onClose={() => setAnchor(null)}
      >
        {onEdit && (
          <MenuItem
            id={`${id}__menuItem_edit_${row.id}`}
            disabled={row.status !== RESOURCE_STATUS.COMPLETED}
            onClick={closeThen(onEdit)}
          >
            Edit
          </MenuItem>
        )}
        <MenuItem id={`${id}__menuItem_delete_${row.id}`} onClick={closeThen(onDelete)}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};
